<template>
    <div>
        <!-- Top filter section -->
        <div class="grid-100 tablet-grid-100 container" style="padding: 16px 24px;">
            <div style="font-size: 20px; font-weight: bold; margin-bottom: 16px;">Import Transload Receipt</div>
            <div class="grid-100 tablet-grid-100" style="margin-bottom: 16px;">
                <div class="grid-20 tablet-grid-25">
                    <predefined-customer-select v-model="searchParam.customerId" @change="onselectCustomerChange" />
                </div>
                <div class="grid-20 tablet-grid-25">
                    <facility-select v-model="searchParam.facility" :customerId="searchParam.customerId" @change="onSelectFacilityChange" />
                </div>
                <div class="grid-20 tablet-grid-25">
                    <label class="input-label" style="visibility: hidden;"></label>
                    <el-upload
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        accept=".xlsx,.xls"
                    >
                        <el-button type="primary">Choose File</el-button>
                    </el-upload>
                    <span v-if="fileName" style="margin-left: 8px; color: #888;">{{ fileName }}</span>
                </div>
            </div>
        </div>

        <!-- Upload Data List -->
        <div class="upload-data-list" v-if="tableColumns && tableColumns.length" style="padding: 0 24px;">
            <div style="font-weight: bold; margin-bottom: 8px;">Upload Data List:</div>
            <el-table :data="paginatedData" style="width: 100%;">
                <el-table-column 
                    v-for="col in tableColumns.filter(col => col !== 'Facility' && col !== 'CustomerID')" 
                    :key="col" 
                    :prop="col" 
                    :label="col" 
                />
                <el-table-column label="Actions" width="80">
                    <template v-slot="scope">
                        <a type="text" size="mini" @click="removeRow(scope.$index)" style="color: #f56c6c; cursor: pointer;">Delete</a>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="sizes, prev, pager, next"
                :total="tableData.length"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                style="margin-top: 20px; text-align: right;"
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
            />
        </div>

        <!-- File Mapping Section -->
        <div class="file-mapping" v-if="tableColumns && tableColumns.length" style="padding: 0 24px; margin-top: 32px;">
            <div style="font-weight: bold; margin-bottom: 8px;">File Mapping:</div>
            <div class="mapping-grid" style="display: flex; flex-wrap: wrap; gap: 16px;">
                <div v-for="field in mappingFields" :key="field" style="width: 260px; display: flex; align-items: center; margin-bottom: 12px;">
                    <span style="width: 140px;">{{ Object.keys(fieldMapping).find(key => fieldMapping[key] === field) }}</span>
                    <el-select v-model="fieldMapping[field]" placeholder="请选择" style="flex: 1;">
                        <el-option 
                            v-for="col in tableColumns.filter(col => !Object.values(fieldMapping).includes(col) || fieldMapping[field] === col)" 
                            :key="col" 
                            :label="col" 
                            :value="col" 
                        />
                    </el-select>
                </div>
            </div>
        </div>

        <!-- Submit Button -->
        <div style="padding: 0 24px; margin-top: 32px; text-align: right;">
            <el-button type="primary" :disabled="!canSubmit" @click="onSubmit">SUBMIT</el-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.import-transload-receipt {
    padding: 24px; /* This class is on the root div in the original, applying padding here for consistency */
}
/* Add any other specific styles for this component if needed */
</style>

<script>
export default {
    data() {
        return {
            // ... existing data properties ...
            currentPage: 1,
            pageSize: 10,
        };
    },
    computed: {
        paginatedData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.tableData.slice(start, end);
        },
    },
    methods: {
        handlePageChange(page) {
            this.currentPage = page;
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // Reset to first page when page size changes
        },
        // ... existing methods ...
    },
};
</script>
